<template>
    <i :class="iconClass" class="ds-text-8xl" />
</template>

<script>
export default {
    props: {
        type: { type: String, required: true },
    },

    computed: {
        iconClass() {
            return {
                warning: 'sr-2 sr-v2-exclamation-circle text-orange-300',
            }[this.type]
        }
    }
}
</script>